import { httpCreate } from './http';

const http = httpCreate('/srv/gather-watch-code/');

export const gatherWatchCode = {
	/**
	 *  白名单列表
	 * @param { Number } albumId 合集ID
	 * @param { Numer } params.isUsed  0-未使用 1-已使用，默认0
	 * @param { Numer } params.pageNum  页码
	 * @param { Numer } params.pageSize  页容量
	 * @returns
	 */
	getWhiteCodeList(albumId, params) {
		return http.get(`/list/${albumId}`, { params });
	},
	// 删除白名单
	deleteWhiteCode(albumId, isUsed, data) {
		return http.post(`/delete/${albumId}/${isUsed}`, data);
	},
	// 清空白名单
	clearWhiteCode(albumId) {
		return http.delete(`/clear/${albumId}`);
	},
	/**
	 * 添加白名单
	 * @param { String } code 白名单字符
	 * @returns
	 */
	singleWhiteCode(albumId, code) {
		return http.post(`/single/${albumId}`, { code: code });
	},
	/**
	 *  自动生成
	 * @param { Number } number 生成数量
	 */
	createWhiteCode(albumId, number) {
		return http.get(`/create/${albumId}`, { number: number });
	},
	// 导入白名单
	importCodeList(albumId, data) {
		return http.post(`/import/${albumId}`, data);
	},
};
